import { useContext, useMemo } from 'react'
import { useFirestoreOrderBy, useFirestoreGeneral } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import { AdressNavigation } from '../../../StateManagment/AdressNavigation'
import EntityMeasurementSummary from '../../Research/EntityMeasurementSummary'
import HouseholdChainNotice from '../HouseholdChainNotice'
import { effectiveResearchDocs } from '../../../helpers/measurementSignals/effectiveResearchIds'

// AI-CONTEXT: See docs/features/meetmoment-signalering.md

const MAX_SHOWN = 3

/**
 * De onderzoeken waaraan dit huishouden meedoet, met per onderzoek wat er is
 * ingevuld en wat er openstaat.
 *
 * De nameting van een huishouden hangt niet aan een termijn maar aan de
 * afronding van het traject; die regel zit in de signalering zelf.
 *
 * Haalt het huishouden zelf op uit de route, net als de andere kaarten op deze
 * Overzicht-tab.
 */
const ResearchCard = () => {
    const adressId = Location()[3]
    const [, setAdressNavigation] = useContext(AdressNavigation)

    const adresses = useFirestoreGeneral('Adresses', 'ID', adressId || '')
    const item = Array.isArray(adresses) ? adresses[0] : null

    const allResearch = useFirestoreOrderBy('Research', 'Position', 'asc')

    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const loaded = Array.isArray(allResearch) && Array.isArray(adresses)

    // Handmatig gekoppeld plus elk onderzoek dat voor alle huishoudens geldt —
    // dezelfde regel als de signalering en de tabs.
    // AI-CONTEXT: See docs/features/automatische-deelname-onderzoek.md
    const linked = useMemo(
        () => effectiveResearchDocs({ kind: 'adress', linkedIds: item?.Research, researches: allResearch })
            .slice(0, MAX_SHOWN),
        [allResearch, item]
    )

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Onderzoeken</h3>
                {/* Helpt een andere organisatie dezelfde woning? Dan hoort dat
                    hier te staan, want anders sturen er twee een nulmeting.
                    AI-CONTEXT: See docs/features/energiearmoede-arnhem-ketensamenwerking.md */}
                <HouseholdChainNotice adressID={adressId} />
                {!loaded ? (
                    <p className="adress-dashboard-empty">Laden…</p>
                ) : linked.length === 0 ? (
                    <p className="adress-dashboard-empty">Nog geen onderzoeken gekoppeld.</p>
                ) : (
                    <EntityMeasurementSummary
                        entityId={adressId}
                        researches={linked}
                        startLabel="In beeld sinds"
                    />
                )}
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setAdressNavigation('research')}
                >
                    Bekijk alle onderzoeken →
                </button>
            </div>
        </div>
    )
}

export default ResearchCard
